
import { DatePipe } from "@angular/common";
import { Component, OnInit, OnDestroy, HostListener, ViewChild, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Location } from '@angular/common';
import { ApiService } from "./services/api.service";
import { SocketService } from "./services/socket.service";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { environment } from "environments/environment";
import { SwPush } from "@angular/service-worker";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],

})
export class AppComponent implements OnInit, OnDestroy {

  day: string;
  month: string;
  date: string;
  time: string;
  gmtValue = environment.gmtvalue;
  timer;
  texts = Array(10).fill('gates');
  ispotrait:boolean;
  ref: MatDialogRef<any>;
  ref1: MatDialogRef<any>;
  rotated:boolean = false
  datatype;
  langvalue;
  environment = environment;
  stepslist = [
    'Tap the "Share" icon located in Browser.',
    'Select "Add to Home Screen" from the options.',
    'Tap "Add" or "Ok" to complete the process.',
    'Access Smart Boarding from home screen.',
    'Enable notifications.',
  ]
  langlist = [{name: 'English',code:'En'},{name:'Italic', code:'It'}]
  private readonly privatekey  = environment.privatekey;
  private readonly publickey = environment.publickey;
  @ViewChild("privacycomponent", { read: TemplateRef, static: false }) privacycomponent: TemplateRef<any>;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkorientation();
    if(this.ispotrait){
      this.rotated = true;
    }
  }

  @HostListener ('window:focus', ['$event'])
  onFocus (event: any): void {
    this.ispotrait = window.innerHeight > window.innerWidth ? true : false 
  }
  datajson = require('./Jsons/'+environment.project+'data.json');
  @ViewChild("DialogComponent", { read: TemplateRef, static: false }) DialogComponent: TemplateRef<any>;
  @ViewChild("notificationComponent", { read: TemplateRef, static: false }) notificationComponent: TemplateRef<any>;
  @ViewChild("nopermission", { read: TemplateRef, static: false }) nopermission: TemplateRef<any>;
  @ViewChild("iOSpopup", { read: TemplateRef, static: false }) iOSpopup: TemplateRef<any>;
  showlang:boolean=false;
  langconfig;
  langcode;
  bahome:boolean = false;
  bahome1:boolean = false;
  bahomes:boolean = false;
  value;
  dialogopened: boolean = false;
  randomDeviceId = '';
  constructor(private devicedetails: DeviceDetectorService, private cookieService: CookieService, private datepipe: DatePipe, public dialog: MatDialog, private location: Location, private apiservice : ApiService, private socketservice: SocketService, private router: Router, private swpush: SwPush) {
    setInterval(() => {
      const dateInGMT = new Date(new Date().toLocaleString('en-US', { timeZone: this.gmtValue }));
      this.time = this.datepipe.transform(dateInGMT, 'HH:mm:ss');
    }, 1000);
    if(!localStorage.getItem('unique_Device_Id')){
      this.generateRandomKey();
    }else { 
      this.randomDeviceId = localStorage.getItem('unique_Device_Id')
    }
    const langcode = sessionStorage.getItem('lang');
    this.langvalue = langcode ? langcode : this.langlist[0].code;
    const langjson = this.langvalue == 'En' ? this.langlist[0] : this.langlist[1];
    this.apiservice.language.next(langjson);
    this.checkurl();
   }
  
  ngOnInit(): void {
    this.checkurl();
    this.checkvalue();
    const langcode = sessionStorage.getItem('lang');
    if(!langcode){
      sessionStorage.setItem('lang', this.langlist[0].code);
      this.apiservice.language.next(this.langlist[0]);
      this.langvalue = this.langlist[0].code
    }
    this.checkorientation();
    this.apiservice.language.subscribe((res)=>{
      this.langcode = res.code
      this.langconfig = this.langcode == 'En' ? require("./Language/En-us.json") : require("./Language/It-us.json")
    })
    this.apiservice.verifyapifailed.subscribe((res)=>{
      if(res == true){
        this.opendialog()
      }
    })
    const gate = sessionStorage.getItem('gate');
    if(gate){
      sessionStorage.removeItem('gate');
      this.socketservice.disconnectSocket();
    }
    this.connectsocket();
  }


  connectsocket(){
    this.socketservice.connectsocket();
  }

  opendialog(){
    this.ref = this.dialog.open(this.DialogComponent);
  }

  checkorientation(){
    this.ispotrait = window.innerHeight > window.innerWidth ? true : false;
  }

  langclick(){
    this.showlang = !this.showlang
  }

  opneprivacy(type){
    if(this.ref){
      this.ref.close();
    }
    this.datatype = type
    this.ref = this.dialog.open(this.privacycomponent);
  }

  changelang(lang){
    sessionStorage.setItem('lang', lang.code);
    this.apiservice.language.next(lang)
    this.langvalue = lang.code;
    this.showlang = false;
  }
  openwebsite(link){
    const weblink = link ? link : this.datajson['webLink']
    window.open(
      weblink,
      "_blank",
    );
  }

  homeiconclick(){
    this.router.navigate(['']);
    history.pushState(null, '','/');
    // this.apiservice.verifyapifailed.next(true)
  }

  setimage() {
    return "../assets/images/airlineLogos/" + this.langvalue + "flag.svg";
  }

  showbalogo:boolean = false;
  checkurl(){
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentUrl = this.router.url;
      if (currentUrl === '/' || currentUrl === '') {
        this.bahome1 = true;
        this.bahome = true;
        sessionStorage.setItem('bahome', 'true');
        return;
      }
      this.bahomes = (sessionStorage.getItem('bahome')) ? true : false;
      if (currentUrl.includes('/service')) {
        this.bahome = true;
        sessionStorage.setItem('bahome', 'true');
        return;
      }
      this.bahomes = (sessionStorage.getItem('bahome')) ? true : false;
      if (currentUrl != '/' || !currentUrl.includes('/services')) {
        this.bahome = false;
        if(!currentUrl.includes('/pax')){
          this.router.navigate(['/']);
        }
      }
    });
  }

  notificationicon() {
    try {
        this.value = localStorage.getItem('notification');
        if (typeof Notification !== 'undefined') {
            if ((Notification.permission === 'denied' && localStorage.getItem('subvalue')) || 
                (Notification.permission === 'default' && localStorage.getItem('subvalue'))) {
                this.apiservice.unsubvalue();
            }
            return this.value === 'true' && Notification.permission === 'granted'
                ? '/assets/images/svg/notificationiconADR.svg'
                : '/assets/images/svg/nonotificationADR.svg';
        } else {
            console.warn('Notification API is not supported in this environment.');
            return '/assets/images/svg/nonotificationADR.svg';
        }
    } catch (error) {
        console.log(error);
    }
  }


  notificationiconclick(){
    if(this.value == 'true'){
      if('Notification' in window){ 
        if(Notification.permission == 'granted'){
          this.savesubscriptoin();
        }else if(Notification.permission == 'denied'){
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.nopermission)
        }else if(Notification.permission == 'default'){
          this.apiservice.setnotification('false')
          this.dialogopened = true;
          this.ref = this.dialog.open(this.notificationComponent)
        }
      }
    }else if(!localStorage.getItem('subvalue')){
      if(!this.dialogopened){
        if('Notification' in window){
          if(Notification.permission == 'granted' || Notification.permission == 'default'){
            this.dialogopened = true;
            this.ref = this.dialog.open(this.notificationComponent)
          }else if(Notification.permission == 'denied'){
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          console.log('no notification show to click on the share');
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }else if(localStorage.getItem('subvalue') && Notification.permission == 'default'){
      Notification.requestPermission().then((res)=>{
        if(res == 'granted'){
          this.apiservice.setnotification('false');
          this.savesubscriptoin();
        }else if(res == 'default'){
          Notification.requestPermission().then(res=>{
            if(res == 'granted'){
              this.apiservice.setnotification('false');
              this.savesubscriptoin();
            }
          })
        }
      })
    }else if(Notification.permission == 'granted'){
      this.savesubscriptoin();
    }else if(Notification.permission == 'denied'){
      if(!this.dialogopened){
        if(this.devicedetails.os != 'iOS'){ // checking notification in the window
          if(Notification.permission == 'denied'){ // condition to handle to show if notifications are denied
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }
  }

  checkvalue(){
    this.apiservice.isbaflight.subscribe((res)=>{
      if(res == true){
        this.bahomes = true;
      }else{
        this.bahome = false;
      }
    })
  }

  grant;
  sub;
  getSubscription(){
    this.apiservice.getsubscriptionvalue();
  }

  savesubscriptoin(){
    this.apiservice.callsavesubscription();
  }

  closedialog1(value){
    if(!value){
      this.dialogopened = false;
      this.ref.close();
    }else{
      this.dialogopened = false;
      const subvalue = localStorage.getItem('subvalue');
      const sub = JSON.parse(subvalue);
      if(!sub){
        this.getSubscription()
      }else if(sub && Notification.permission == 'granted'){
        this.savesubscriptoin();
      }else if(sub && Notification.permission == 'default'){
        Notification.requestPermission().then((res)=>{
          if(res == 'granted'){
            this.savesubscriptoin();
          }
        })
      }
      this.ref.close();
    }
  }

  closedialog(){
    this.ref.close();
  }
  
  closedialog2(){
    this.dialogopened = false;
    this.ref1.close();
  }

  
  ngOnDestroy(){
    clearInterval(this.timer);
    this.socketservice.disconnectserver();
  }

  generateRandomKey() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=';
    let randomKey = '';
    for (let i = 0; i < 7; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomKey += characters[randomIndex];
    }
    this.randomDeviceId = randomKey;
    localStorage.setItem('unique_Device_Id', this.randomDeviceId);
}

}
